module.exports = __webpack_public_path__ + "img/tree-01-c-leaves.7c78efd2.png";